import { render, staticRenderFns } from "./AccountSidebarNav.vue?vue&type=template&id=874afc4e&scoped=true&"
import script from "./AccountSidebarNav.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874afc4e",
  null
  
)

export default component.exports